/**
 * useDescription
 * @author @jstarsky
 * @param {*} input
 * @return {Object}
 */
const useDescription = ({ id, type, alignment }) => {
  /**
   * setColor
   * @author @jstarsky
   * @param {String} input color
   * @return {String}
   * https://tailwindcss.com/docs/font-family#header
   */
  const setColor = (input) => {
    switch (input) {
      case 'alert':
        return ' tw-text-alert'
      case 'warning':
        return ' tw-text-warning'
      case 'required':
        return ' tw-text-alert'
      case 'validate':
        return ' tw-text-alert'
      case 'pattern':
        return ' tw-text-alert'
      case 'info':
        return ' tw-text-black'
      default:
        return ''
    }
  }
  /**
   * setAlingment
   * @author @jstarsky
   * @param {String} input alingment "center", "end", "start"
   * @return {String}
   * https://tailwindcss.com/docs/font-family#header
   */
  const setAlingment = (input) => {
    switch (input) {
      case 'start':
        return ' tw-justify-start'
      case 'center':
        return ' tw-justify-center'
      case 'end':
        return ' tw-justify-end'
      default:
        return ''
    }
  }

  return {
    internalClassName: `${id} tw-m-0 tw-flex tw-flex-1 tw-leading-none${setAlingment(
      alignment
    )}`,
    paragraphsClassName: `${setColor(type)}`
  }
}

export default useDescription
